import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MotivationFullDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { MoovData } from 'src/app/moov-common/services/challenge/challenges-data';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-moov-tile-web',
  templateUrl: './moov-tile-web.component.html',
  styleUrls: ['./moov-tile-web.component.scss']
})
export class MoovTileWebComponent extends BaseComponent implements OnInit {
  
  moovsImagesRootFolder = 'assets/moovs/';
  @Input() currMoov: MoovData;
  @Input() isMoovActive: boolean = false;
  @Input() isTopMoov: boolean = false;
  @Input() doesHavePast: boolean = false;
  @Input() isBestMoov: boolean = false;
  @Output() openMoovEvent = new EventEmitter<{ moovId:string, isTopMoov:boolean }>();

  motivationDetails : MotivationFullDetails;
  constructor(private readonly motivationsService: AbstractMotivationsService) { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getMotivationDetails();
  }

  openMoov(moovId: string, isTopMoov: boolean) {
    this.openMoovEvent.emit({moovId, isTopMoov});
    
  }

  getMotivationDetails (): void{
    if (this.currMoov != undefined){
      // console.log(`in MTW getMoptivationDetails motivation id is ${this.currMoov.motivationId}`);
      this.motivationDetails = this.motivationsService.getPartialMotivationDetails(this.currMoov.motivationId);
    }
    
  }

}
